import React from 'react';
import figma from '../../assets/figma.png';
import html from '../../assets/html.png';
import css from '../../assets/css.png';
import miro from '../../assets/miro.png';
import javascript from '../../assets/javascript.png';
import node from '../../assets/node.png';
import firebase from '../../assets/firebase.png';
import github from '../../assets/github.png';
import react from '../../assets/react.png';
import tailwind from '../../assets/tailwind.png';
import mongodb from '../../assets/mongodb.png';
import './Skills.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";

const Skills = () => {
    const techs = [
        {
            id: 1,
            src: figma,
            title: "Figma",
            value: 90,
            style: "shadow-red-400"
        },
        {
            id: 2,
            src: miro,
            title: "Miro",
            value: 70,
            style: "shadow-yellow-500",
        },
        {
            id: 3,
            src: html,
            title: "HTML",
            value: 90,
            style: "shadow-orange-500",
        },
        {
            id: 4,
            src: css,
            title: "CSS",
            value: 90,
            style: "shadow-blue-500",
        },
        {
            id: 5,
            src: javascript,
            title: "JavaScript",
            value: 70,
            style: "shadow-yellow-500",
        },
        {
            id: 6,
            src: react,
            title: "React",
            value: 90,
            style: "shadow-blue-600",
        },
        {
            id: 7,
            src: tailwind,
            title: "Tailwind",
            value: 90,
            style: "shadow-sky-400",
        },
        {
            id: 8,
            src: firebase,
            title: "Firebase",
            value: 60,
            style: "shadow-yellow-500",
        },
        {
            id: 9,
            src: node,
            title: "NodeJs",
            value: 60,
            style: "shadow-lime-300",
        },
        {
            id: 10,
            src: github,
            title: "GitHub",
            value: 60,
            style: "shadow-gray-400",
        },
        {
            id: 11,
            src: mongodb,
            title: "MongoDB",
            value: 60,
            style: "shadow-green-400",
        },
    ];

    return (
        <div
            name="skills"
            className="bg-[#070716]"
        >
            <div className="p-4 text-white">
                <div className="text-center">
                    <p className='text'><span className='ml-12 text-sm'>check out my</span></p>
                    <p className="text-3xl font-bold inline">
                        Skills
                    </p>
                </div>
                <div className='max-w-xs md:max-w-2xl lg:max-w-5xl mx-auto my-16'>
                    <Swiper
                        style={{
                            "--swiper-navigation-color": "#fff",
                            "--swiper-navigation-size": "18px",
                        }}
                        freeMode={true}
                        grabCursor={true}
                        modules={[FreeMode, Autoplay, Pagination, Navigation]}
                        className="mySwiper"
                        speed={500}
                        breakpoints={{
                            0: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                            },
                            1024: {
                                slidesPerView: 5,
                                spaceBetween: 10,
                            },
                            1280: {
                                slidesPerView: 5,
                                spaceBetween: 10,
                            },
                        }}
                        autoplay={{
                            delay: 1500,
                            disableOnInteraction: false,
                        }}
                    >


                        {techs.map(({ id, src, title, style, value }) => (
                            <SwiperSlide>
                                <div
                                    key={id}
                                    className={`shadow-md hover:scale-105 duration-500 m-2 py-7 rounded-lg ${style}`}>
                                    <img src={src} alt="" className="w-20 mx-auto" />
                                    <p className="mt-4 text-center">{title}</p>
                                </div>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default Skills;